import React from "react";
import { App, Upload, Spin } from "antd";
import { FaRegAddressCard } from "react-icons/fa6";
//
import { base64Image } from "../util/image";
// component
// redux
import placeholder from "asset/img/placeholder/img_placeholder.png";

const UploadImage = (props) => {
  const { message } = App.useApp();
  // -------------------------- VAR --------------------------
  const label = props?.label || "Ảnh";
  const loading = props?.loading || false;
  const disabled = props?.disabled || loading;
  const image = props?.image || "";
  const width = props?.width || 400;
  const height = props?.height || 200;
  const icon = props?.icon || <FaRegAddressCard size={30} color="#aeaeae" />;

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  const beforeUpload = (file) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/webp";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const handleUpload = async (action) => {
    const file = action.file;
    base64Image(file, width, height).then((preview) => {
      props.onChange(preview);
    });
  };

  const onChange = ({ files }) => {
    console.log({ files });
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------

  const renderFeature = () => {
    return (
      <img
        src={image}
        alt="CCCD / CMND"
        style={{
          width: "100%",
          borderRadius: 10,
        }}
        onError={(e) => {
          e.target.src = placeholder;
          e.target.style.backgroundColor = "#fff";
        }}
      />
    );
  };

  const renderButton = () => {
    return (
      <div style={{ position: "relative", textAlign: "center" }}>
        {icon}
        <div style={{ marginTop: 8, fontSize: 18, color: "#999" }}>{label}</div>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Upload
      showUploadList={false}
      disabled={disabled}
      onChange={onChange}
      customRequest={handleUpload}
      beforeUpload={beforeUpload}
      maxCount={1}
      multiple={false}
    >
      <div
        style={{
          maxWidth: width,
          minHeight: height,
          background: "#f1f1f1",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 10,
          border: "2.5px dashed rgba(0,0,0,0.2)",
          padding: 4,
          overflow: "hidden",
          cursor: "pointer",
        }}
      >
        {loading ? <Spin /> : image ? renderFeature() : renderButton()}
      </div>
    </Upload>
  );
};

export default UploadImage;
